enum AnnotationNoteDialogFields {
	CREATOR = "creator",
	SUBJECT = "subject",
	CONTENTS = "contents",
	INTENTS = "intents",
	ICON = "icon",
	COLOR = "color",
	OPACITY = "opacity",
}

export default AnnotationNoteDialogFields;